import {
  InfoModule,
  createInfoServices
} from "./chunk-LBM3YZW2.mjs";
import "./chunk-FPAJGGOC.mjs";
export {
  InfoModule,
  createInfoServices
};
